import React from 'react'
import styled from 'styled-components'
import Section from '../../Section'
import { SEVERITY_DESCRIPTION, SEVERITY_ID } from '../../../constants'

const Container = styled.ul`
  li {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
`

const Definition = styled.b`
  color: ${props => props.color};
`

const Definitions = () => (
  <Section title="Definitions">
    <Container>
      <li>
        <Definition color="#A92756">High severity</Definition> –{' '}
        {SEVERITY_DESCRIPTION[SEVERITY_ID.HIGH]}
      </li>
      <li>
        <Definition color="#E48D12">Medium severity</Definition> –{' '}
        {SEVERITY_DESCRIPTION[SEVERITY_ID.MEDIUM]}
      </li>
      <li>
        <Definition color="#1670DA">Low severity</Definition> –{' '}
        {SEVERITY_DESCRIPTION[SEVERITY_ID.LOW]}
      </li>
      <li>
        <Definition color="#208F61">Informational</Definition> –{' '}
        {SEVERITY_DESCRIPTION[SEVERITY_ID.INFORMATIONAL]}
      </li>
      <li>
        <Definition color="#414346">Undetermined</Definition> –{' '}
        {SEVERITY_DESCRIPTION[SEVERITY_ID.UNDETERMINED]}
      </li>
      <li>
        <Definition color="#0C5B00">Fixed</Definition> – Adjusted program implementation,
        requirements or constraints to eliminate the risk.
      </li>
      <li>
        <Definition color="#814D00">Mitigated</Definition> – Implemented actions to minimize the
        impact or likelihood of the risk.
      </li>
      <li>
        <Definition color="#002B9A">Acknowledged</Definition> – The issue remains in the code but is
        a result of an intentional business or design decision. As such, it is supposed to be
        addressed outside the programmatic means, such as: 1) comments, documentation, README, FAQ;
        2) business processes; 3) analyses showing that the issue shall have no negative
        consequences in practice (e.g., gas analysis, deployment settings).
      </li>
    </Container>
  </Section>
)

export default Definitions
